import React, { memo } from "react";

interface BackButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

interface NextButtonProps {
  onClick: () => void;
  isLastStep?: boolean;
  className?: string;
  disabled?: boolean;
}

export const BackButton: React.FC<BackButtonProps> = memo(
  ({ onClick, disabled = false, className = "" }) => {
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        className={`text-neutral-600 font-light text-xs border border-neutral-200 hover:text-neutral-900 hover:bg-neutral-100 py-2 rounded-full px-3 transition ease-in-out duration-500 ${className}`}
      >
        <i className="fa-regular fa-arrow-left mr-2 text-xs" />
        Back
      </button>
    );
  }
);

export const NextButton: React.FC<NextButtonProps> = memo(
  ({ onClick, isLastStep = false, className = "", disabled = false }) => {
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        className={`bg-indigo-50 font-light text-xs ring-1 ring-indigo-600 hover:ring-indigo-800 py-2 rounded-full text-indigo-600 hover:bg-indigo-100 transition ease-in-out duration-500 px-3 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      >
        {isLastStep ? (
          <>
            Submit
            <i className="fa-regular fa-check ml-2 text-xs" />
          </>
        ) : (
          <>
            Next
            <i className="fa-regular fa-arrow-right ml-2 text-xs" />
          </>
        )}
      </button>
    );
  }
);
